export var InteractionStatus;
(function (InteractionStatus) {
    InteractionStatus[InteractionStatus["WAITING"] = 100] = "WAITING";
    InteractionStatus[InteractionStatus["TRANSFERRED_WAITING"] = 101] = "TRANSFERRED_WAITING";
    InteractionStatus[InteractionStatus["ACTIVE"] = 200] = "ACTIVE";
    InteractionStatus[InteractionStatus["COMPLETED"] = 300] = "COMPLETED";
    InteractionStatus[InteractionStatus["TRANSFERRED"] = 301] = "TRANSFERRED";
    InteractionStatus[InteractionStatus["PENDING_OUTBOUND"] = 400] = "PENDING_OUTBOUND";
})(InteractionStatus || (InteractionStatus = {}));
//# sourceMappingURL=interaction-status.enum.js.map